export default "__VITE_ASSET__DoJVlt2h__"